import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import AOS from 'aos'
import {Form} from './forms/form';
import Translator from 'gettext-translator';
import VueCropper from 'vue-cropperjs';

import LoginForm from './auth/LoginForm';
import NavigationBar from './common/NavigationBar';
import MyQuizzes from './my-quizzes/MyQuizzes';
import MyQuizzesLegend from './my-quizzes/MyQuizzesLegend';
import MyQuizzesBoardView from './my-quizzes/MyQuizzesBoardView';
import MyQuizzesListView from './my-quizzes/MyQuizzesListView';
import MyQuizzesSetModal from './my-quizzes/MyQuizzesSetModal';
import MyQuizzesDeleteElementsModal from './my-quizzes/MyQuizzesDeleteElementsModal';
import MyQuizzesDeleteElementsHint from './my-quizzes/MyQuizzesDeleteElementsHint';
import MyQuizzesGameModal from './my-quizzes/MyQuizzesGameModal';
import MyQuizzesEditGame from './my-quizzes/MyQuizzesEditGame';
import MyQuizzesSaveEmptyFieldsModal from './my-quizzes/MyQuizzesSaveEmptyFieldsModal';
import MyQuizzesGameCategoryModal from './my-quizzes/MyQuizzesGameCategoryModal';
import MyQuizzesCategoryHint from './my-quizzes/MyQuizzesCategoryHint';
import MyQuizzesImportDataModal from './my-quizzes/MyQuizzesImportDataModal';
import FileManager from './file-manager/FileManager.vue';
import FileManagerModal from './file-manager/FileManagerModal.vue';
import FileManagerImageSelect from './file-manager/FileManagerImageSelect.vue';
import FileManagerImagesSelect from './file-manager/FileManagerImagesSelect.vue';
import FileManagerAudioSelect from './file-manager/FileManagerAudioSelect.vue';
import FileManagerFileSelect from './file-manager/FileManagerFileSelect.vue';
import FileManagerFilesSelect from './file-manager/FileManagerFilesSelect.vue';
import FileManagerPathSelect from './file-manager/FileManagerPathSelect.vue';
import FileManagerBrowse from './file-manager/FileManagerBrowse.vue';
import Resources from './resources/Resources.vue';
import Contact from './contact/Contact.vue';
import PresentationPackage from './presentation-package/PresentationPackage';
import PresentationPackageBoardView from './presentation-package/PresentationPackageBoardView';
import PresentationPackageListView from './presentation-package/PresentationPackageListView';
import PresentationPackagePresentationModal from './presentation-package/PresentationPackagePresentationModal';
import PresentationPackageDeleteElementsModal from './presentation-package/PresentationPackageDeleteElementsModal';
import PersonalizedGameEditor from './personalized-games/PersonalizedGameEditor';
import PersonalizedGameEditorNode from './personalized-games/PersonalizedGameEditorNode';
import PersonalizedGameEditorElement from './personalized-games/PersonalizedGameEditorElement';
import PersonalizedGameEditorBool from './personalized-games/PersonalizedGameEditorBool';
import PersonalizedGameEditorNumber from './personalized-games/PersonalizedGameEditorNumber';
import PersonalizedGameEditorString from './personalized-games/PersonalizedGameEditorString';
import PersonalizedGameEditorColor from './personalized-games/PersonalizedGameEditorColor';
import PersonalizedGameEditorChoice from './personalized-games/PersonalizedGameEditorChoice';
import PersonalizedGameEditorImage from './personalized-games/PersonalizedGameEditorImage';
import PersonalizedGameEditorList from './personalized-games/PersonalizedGameEditorList';
import PersonalizedGameEditorAudio from './personalized-games/PersonalizedGameEditorAudio';
import PersonalizedGameEditorMockup from './personalized-games/PersonalizedGameEditorMockup';
import PersonalizedGameResetPackage from './personalized-games/PersonalizedGameResetPackage.vue';
import SynchronizationColumn from './common/SynchronizationColumn';


const t = new Translator(window.CONFIG.translations);
window.t = t;

window.Vue = Vue;
window.axios = require('axios');

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["X-CSRF-TOKEN"] = document.querySelector('meta[name="csrf-token"]').content;

axios.interceptors.response.use(function(response){
    return response;
}, function(error){
    if (error.response.status === 401 || error.response.status === 419) {
        window.location.reload();
    }
    return Promise.reject(error);
});

Vue.prototype.Form = Form;
Vue.prototype.t = window.t;
Vue.prototype.CONFIG = window.CONFIG;

Vue.use(BootstrapVue);
Vue.component('vue-cropper', VueCropper);
Vue.component('login-form', LoginForm);
Vue.component('navigation-bar', NavigationBar);
Vue.component('my-quizzes', MyQuizzes);
Vue.component('my-quizzes-legend', MyQuizzesLegend);
Vue.component('my-quizzes-board-view', MyQuizzesBoardView);
Vue.component('my-quizzes-list-view', MyQuizzesListView);
Vue.component('my-quizzes-set-modal', MyQuizzesSetModal);
Vue.component('my-quizzes-delete-elements-modal', MyQuizzesDeleteElementsModal);
Vue.component('my-quizzes-delete-elements-hint', MyQuizzesDeleteElementsHint);
Vue.component('my-quizzes-game-modal', MyQuizzesGameModal);
Vue.component('my-quizzes-edit-game', MyQuizzesEditGame);
Vue.component('my-quizzes-save-empty-fields-modal', MyQuizzesSaveEmptyFieldsModal);
Vue.component('my-quizzes-game-category-modal', MyQuizzesGameCategoryModal);
Vue.component('my-quizzes-category-hint', MyQuizzesCategoryHint);
Vue.component('my-quizzes-import-data-modal', MyQuizzesImportDataModal);
Vue.component('file-manager', FileManager);
Vue.component('file-manager-modal', FileManagerModal);
Vue.component('file-manager-image-select', FileManagerImageSelect);
Vue.component('file-manager-images-select', FileManagerImagesSelect);
Vue.component('file-manager-audio-select', FileManagerAudioSelect);
Vue.component('file-manager-file-select', FileManagerFileSelect);
Vue.component('file-manager-files-select', FileManagerFilesSelect);
Vue.component('file-manager-path-select', FileManagerPathSelect);
Vue.component('file-manager-browse', FileManagerBrowse);
Vue.component('resources', Resources);
Vue.component('contact', Contact);
Vue.component('presentation-package', PresentationPackage);
Vue.component('presentation-package-board-view', PresentationPackageBoardView);
Vue.component('presentation-package-list-view', PresentationPackageListView);
Vue.component('presentation-package-presentation-modal', PresentationPackagePresentationModal);
Vue.component('presentation-package-delete-elements-modal', PresentationPackageDeleteElementsModal);
Vue.component('personalized-game-editor', PersonalizedGameEditor);
Vue.component('personalized-game-editor-node', PersonalizedGameEditorNode);
Vue.component('personalized-game-editor-element', PersonalizedGameEditorElement);
Vue.component('personalized-game-editor-bool', PersonalizedGameEditorBool);
Vue.component('personalized-game-editor-number', PersonalizedGameEditorNumber);
Vue.component('personalized-game-editor-string', PersonalizedGameEditorString);
Vue.component('personalized-game-editor-color', PersonalizedGameEditorColor);
Vue.component('personalized-game-editor-choice', PersonalizedGameEditorChoice);
Vue.component('personalized-game-editor-image', PersonalizedGameEditorImage);
Vue.component('personalized-game-editor-list', PersonalizedGameEditorList);
Vue.component('personalized-game-editor-audio', PersonalizedGameEditorAudio);
Vue.component('personalized-game-editor-mockup', PersonalizedGameEditorMockup);
Vue.component('personalized-game-reset-package', PersonalizedGameResetPackage);
Vue.component('synchronization-column', SynchronizationColumn)


// Event handler
if (!window.eventHub) {
    window.eventHub = new Vue();
}

let app = new Vue({

    el: '#app',

    data() {
        return {
            eventHub: window.eventHub,
            fileManager: {
                show: false,
                modal: false,
                eventName: null,
                mimeTypes: null,
                basePath: null,
                disableWriteAccess: false,
                openUploadDirectly: false,
                multipleFilesSelect: false
            }
        }
    },

    computed: {

    },

    created () {
        AOS.init({
            once: true
        })
    },

    mounted() {

        this.eventHub.$on('show-file-manager', (uid, selectType, mimeTypes, basePath = null, disableWriteAccess = false, openUploadDirectly = false, multipleFilesSelect = false) => {
            // console.log(uid, selectType, mimeTypes, basePath, disableWriteAccess);
            this.fileManager.eventName = uid;
            this.fileManager.mimeTypes = mimeTypes;
            this.fileManager.modal = selectType;
            this.fileManager.basePath = basePath;
            this.fileManager.disableWriteAccess = disableWriteAccess;
            this.fileManager.openUploadDirectly = openUploadDirectly;
            this.fileManager.multipleFilesSelect = multipleFilesSelect;
            this.$bvModal.show('file-manager-modal');
        });

        this.eventHub.$on('hide-file-manager', () => {
            this.$bvModal.hide('file-manager-modal');
            this.fileManager.modal = false;
            this.fileManager.basePath = null;
            this.fileManager.disableWriteAccess = false;
            this.fileManager.openUploadDirectly = false;
            this.fileManager.multipleFilesSelect = false;
            this.fileManager.eventName = null;
        });

    },

    methods: {

        onOver(ref) {
            this.$refs[ref].visible = true;
        },

        onLeave(ref) {
            this.$refs[ref].visible = false;
        }


    }
});
